import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, {
    SelectOption,
    TextareaField,
    addOption
} from '../../../../../utils/InputField';
import { handleEditProductOpe } from '../../ProductOperation';

function EditProductModal({ data, handleReload, closeEditProductModal }) {
    const { id, applicationTitle, description, website, status, logoUrl } = data;
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setMessage } = useTemplate();

    const [formData, setFormData] = useState({
        Id: id || 0,
        ApplicationTitle: applicationTitle || '',
        Description: description || '',
        Website: website || '',
        LogoUrl: logoUrl || '',
        Status: status || ''
    });

    const isProductInactive = status !== 'active';

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'Website') {
            setFormData((d) => ({ ...d, Website: value }));
            return;
        }

        setFormData((d) => ({ ...d, [name]: value }));
    };

    const handleEditCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        handleEditProductOpe(id, formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                closeEditProductModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleEditCustomer} className="flex flex-col gap-4">
            <InputField
                label="Application Title"
                name="ApplicationTitle"
                formData={formData}
                onChange={handleChange}
                disabled={isProductInactive}
            />
            <TextareaField
                label="Description"
                name="Description"
                formData={formData}
                onChange={handleChange}
                disabled={isProductInactive}
            />
            <div className="h-18 flex flex-col">
                <div
                    className={`w-full h-auto mb-2 flex flex-row justify-start items-center gap-x-2 ${
                        isProductInactive ? 'grayscale pointer-events-none' : ''
                    }`}
                >
                    <span>Website Url</span>
                    {formData.Website ? (
                        <Link
                            to={formData?.Website || '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-warning/10 text-warning px-2 py-px rounded-md focus:outline focus:outline-1 focus:outline-primary-200"
                        >
                            Check
                        </Link>
                    ) : (
                        <span className="bg-warning/10 text-warning px-2 py-px rounded-md focus:outline focus:outline-1 focus:outline-primary-200 cursor-default">
                            Check
                        </span>
                    )}
                </div>
                <InputField
                    placeholder="https://www.example.com"
                    name="Website"
                    formData={formData}
                    onChange={handleChange}
                    disabled={isProductInactive}
                />
            </div>

            <SelectOption
                label="Status"
                name="Status"
                formData={formData}
                onChange={handleChange}
                options={['Active', 'Inactive'].map((d) => addOption(d, d, d.toLowerCase()))}
            />
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeEditProductModal()} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default EditProductModal;
